// extracted by mini-css-extract-plugin
export default {"shared_icon_text":"orders-list_shared_icon_text__GQLFk"};